module.exports = __webpack_public_path__ + "static/media/LitresLogo.bcd46514.png";